import React from 'react';
import { useSelector } from 'react-redux';

import Grid from '@mui/material/Grid2';

import useSite from '../../../../store/hooks/useSite';
import useMeter from '../../../../store/hooks/useMeter';
import useSensor from '../../../../store/hooks/useSensor';
import SensorChart from '../../../../components/charts/analysis/SensorChart';

export default function Analysis() {
  const { id } = useSelector((state) => state.pages.sensor);
  const sensor = useSensor(id);
  const meter = useMeter(sensor.meter_id);
  const site = useSite(meter.site_id);

  return (
    <Grid
      container
      spacing={1}
      direction='row'
      justifyContent='center'
      alignItems='center'
      sx={{ mt: 1, px: 2, width: '100%' }}>
      <SensorChart site={site} sensor={sensor} />
    </Grid>
  );
}
